import { styled } from '@linaria/react';

import { Text } from '~components/Typography';

export const TOCWrapper = styled(Text)`
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	gap: var(--gap-x2);
`;
